import { NgSelectModule } from '@ng-select/ng-select';
import { ApplicationsComponent } from './applications.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AuthorizationModule } from '../../modules/authorization/authorization.module';
import { AssignResourceComponent } from './components/assign-resource/assign-resource.component';
import { TableModule } from '../../lib';
import { SharedModule } from '../../modules/shared/shared.module';
import { MaterialModule } from '../../modules/material/material.module';
import { CapitalizeFirstPipe } from '../capitalize-first.pipe';
import { SharedModule as libSharedModule } from 'shared-library';

const routes: Routes = [
  { path: '', pathMatch: "full", component: ApplicationsComponent },
  { path: 'assignResource', pathMatch: "full", component: AssignResourceComponent },
]


@NgModule({
  declarations: [
    ApplicationsComponent,
    AssignResourceComponent
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    FormsModule,
    RouterModule.forChild(routes),
    TableModule,
    SharedModule,
    MaterialModule,
    NgSelectModule,
    AuthorizationModule,
    NgbModule,
    CapitalizeFirstPipe ,
    libSharedModule
   ]
})
export class ApplicationsModule { }
